<template>
  <div class="gym-page legal-page" id="top">
    <GymNavBar />

    <main class="legal-wrapper">
      <div class="legal-container">
        <div class="legal-header">
          <h1>Όροι Χρήσης</h1>
          <p class="legal-subtitle">Τελευταία ενημέρωση: Μάρτιος 2026</p>
        </div>

        <div class="legal-body">
          <p>
            Κάθε επισκέπτης ή χρήστης του διαδικτυακού μας τόπου οφείλει να διαβάσει και να μελετήσει προσεκτικά τους
            όρους χρήσης που ακολουθούν, πριν από την επίσκεψη ή τη χρήση των σελίδων και σε περίπτωση διαφωνίας οφείλει
            να μην κάνει χρήση τους. Ειδάλλως τεκμαίρεται ότι τους αποδέχεται ρητά και ανεπιφύλακτα και παραχωρεί τη
            συγκατάθεσή του. Οι κατωτέρω όροι χρήσης ισχύουν για το σύνολο του περιεχομένου του διαδικτυακού μας τόπου
            και μαζί με τους εκάστοτε εφαρμοστέους Πρόσθετους Νόμιμους Όρους συνιστούν ενιαία, νομικά δεσμευτική
            συμφωνία μεταξύ της «ΝΙΚΟΛΑΟΣ ΒΟΥΡΛΙΔΑΣ» (εφεξής "ΕΤΑΙΡΕΙΑ") και των Χρηστών σχετικά με την πρόσβαση και
            τη χρήση από αυτούς της ιστοσελίδας ctgym.cloudtec.gr (εφεξής "ΙΣΤΟΣΕΛΙΔΑ").
          </p>

          <p>
            Η "ΕΤΑΙΡΕΙΑ" δύναται οποιαδήποτε χρονική στιγμή να τροποποιεί τους όρους χρήσης και τις προϋποθέσεις για
            οποιονδήποτε λόγο και χωρίς προειδοποίηση και θα καταβάλλει κάθε δυνατή προσπάθεια για να υποδείξει τις
            όποιες αλλαγές στους όρους αυτούς με ειδοποίηση στην αρχική σελίδα της "ΙΣΤΟΣΕΛΙΔΑΣ" ή μέσω ηλεκτρονικού
            ταχυδρομείου (e-mail) ή ενημερώνοντας τους Όρους Χρήσης που βρίσκονται στο σύνδεσμο «Όροι Χρήσης» στο
            κάτω μέρος της αρχικής σελίδας της "ΙΣΤΟΣΕΛΙΔΑΣ", οι δε Χρήστες / επισκέπτες οφείλουν κάθε φορά να
            ελέγχουν για ενδεχόμενες αλλαγές και εφόσον εξακολουθούν τη χρήση τεκμαίρεται ότι αποδέχονται ρητά και
            ανεπιφύλακτα τους τροποποιημένους όρους και προϋποθέσεις. Σε αντίθετη περίπτωση οφείλουν να απέχουν την
            επίσκεψη στο διαδικτυακό μας τόπο.
          </p>

          <p>
            H "ΕΤΑΙΡΕΙΑ" καταβάλλει κάθε προσπάθεια ώστε το περιεχόμενο και οι πληροφορίες που εμφανίζονται κάθε
            φορά στο διαδικτυακό της τόπο να είναι κατά το δυνατόν ακριβή και αληθή, δεν φέρει όμως καμία ευθύνη για
            την αξιοπιστία, πληρότητα ή επικαιρότητα τους. Ο,τιδήποτε παρέχεται στους χρήστες / επισκέπτες μέσω του
            διαδικτυακού μας τόπου δεν αποτελεί σε καμία περίπτωση, ευθέως ή εμμέσως, παρότρυνση, συμβουλή ή
            προτροπή για τη διενέργεια οποιαδήποτε πράξεως αλλά εναπόκειται στη διακριτική ευχέρεια των χρηστών /
            επισκεπτών να αξιολογήσουν ό,τι τους παρέχεται και να ενεργήσουν βασιζόμενοι στην ιδιωτική τους βούληση,
            αποκλειόμενης οποιασδήποτε δικής μας ευθύνης.
          </p>

          <p>
            Ο χρήστης/ επισκέπτης που χρησιμοποιεί τις υπηρεσίες του διαδικτυακού μας τόπου υποχρεούται, να το κάνει
            σύμφωνα με το νόμο, τα χρηστά ήθη και τους παρόντες όρους και να μην προβαίνει σε πράξεις ή παραλείψεις
            που μπορούν να προκαλέσουν βλάβη στη λειτουργία του διαδικτυακού τόπου ή σε πνευματικά δικαιώματα τρίτων.
          </p>

          <h2>Δήλωση Αποποίησης Ευθύνης</h2>

          <p>
            Η "ΕΤΑΙΡΕΙΑ" δεν φέρει καμία ευθύνη για οποιαδήποτε ενέργεια προσώπου ή οργανισμού, οπουδήποτε και αν
            αυτοί εδρεύουν, σαν αποτέλεσμα, άμεσο ή έμμεσο των πληροφοριών που περιλαμβάνονται ή γίνονται διαθέσιμες
            μέσα από αυτή την ιστοσελίδα, ανεξάρτητα του αν οι πληροφορίες αυτές παρέχονται από την "ΙΣΤΟΣΕΛΙΔΑ" ή
            κάποιο άλλο τρίτο μέρος.
          </p>

          <p>
            Η "ΕΤΑΙΡΕΙΑ" σε καμία περίπτωση δεν φέρει ευθύνη για τυχόν απαιτήσεις νομικής ή αστικής ή και ποινικής
            φύσεως ούτε για τυχόν ζημία από επισκέπτες του διαδικτυακού μας τόπου ή τρίτους από αιτία που έχει σχέση
            με τη λειτουργία ή μη ή και τη χρήση του διαδικτυακού τόπου ή των πληροφοριών που περιέχονται σε αυτόν ή
            και σε αδυναμία παροχής υπηρεσιών ή και πληροφοριών που διατίθενται από αυτόν ή και από τυχόν μη
            επιτρεπόμενες παρεμβάσεις τρίτων σε προϊόντα ή και υπηρεσίες ή και πληροφορίες που διατίθενται μέσω αυτού.
          </p>

          <p>
            Η "ΕΤΑΙΡΕΙΑ" και οι συνεργάτες της καταβάλουν κάθε δυνατή προσπάθεια για την καλή λειτουργία του
            διαδικτυακού της τόπου, χωρίς να εγγυώνται ότι οι λειτουργίες του ή των servers που το φιλοξενούν, θα
            είναι αδιάκοπες ή χωρίς κανενός είδους σφάλμα, απαλλαγμένες από ιούς ή άλλα παρόμοια στοιχεία. Η
            "ΕΤΑΙΡΕΙΑ" και οι συνεργάτες της δεν φέρουν καμία ευθύνη για καταστροφές οποιασδήποτε μορφής που μπορούν
            να πραγματοποιηθούν από την χρήση του παρόντος διαδικτυακού τόπου συμπεριλαμβανομένων, αλλά όχι
            περιορισμένων, σε άμεσες, έμμεσες, τυχαίες, συμπτωματικές και επακόλουθες, οπωσδήποτε και αν αυτές
            προκλήθηκαν, είτε συμβατικά είτε άλλως.
          </p>

          <h2>Δικαιώματα πνευματικής και βιομηχανικής ιδιοκτησίας</h2>

          <p>
            Εκτός των ρητά αναφερόμενων εξαιρέσεων (πνευματικά δικαιώματα τρίτων, συνεργατών και φορέων, όπως και η
            πνευματική ιδιοκτησία του πηγαίου κώδικα, η οποία ανήκει στην εταιρεία που έχει κατασκευάσει τον
            διαδικτυακό τόπο) όλο το περιεχόμενο του δικτυακού τόπου, συμπεριλαμβανομένων όλων των αρχείων αυτού του
            δικτυακού τόπου, αποτελούν πνευματική ιδιοκτησία, κατατεθειμένα σήματα και σήματα υπηρεσιών και προϊόντων
            της "ΕΤΑΙΡΕΙΑΣ" και προστατεύονται κατά τις σχετικές διατάξεις του ελληνικού δικαίου, του ευρωπαϊκού
            δικαίου και των διεθνών συμβάσεων.
          </p>

          <p>
            Η μη εξουσιοδοτημένη αντιγραφή, διανομή, τροποποίηση, δημόσια έκθεση ή δημόσια εκτέλεση έργων επί των
            οποίων έχει ιδρυθεί δικαίωμα πνευματικής ιδιοκτησίας συνιστά παραβίαση των δικαιωμάτων του δικαιούχου
            πνευματικής ιδιοκτησίας. Οι Χρήστες συμφωνούν ότι δεν θα χρησιμοποιήσουν τον δικτυακό τόπο για να
            παραβιάσουν τα δικαιώματα πνευματικής ιδιοκτησίας της "ΕΤΑΙΡΕΙΑΣ" ή άλλων καθ' οιονδήποτε τρόπο.
            Απαγορεύεται η μετακίνηση, επιτύπωση ή παραμόρφωση οποιασδήποτε ειδοποίησης δικαιώματος πνευματικής
            ιδιοκτησίας, εμπορικού σήματος, λογοτύπου ή άλλης ειδοποίησης ιδιοκτησίας κάθε πρωτοτύπου ή αντιγράφου
            του Περιεχομένου προς το οποία δίδεται πρόσβαση μέσω του δικτυακού τόπου.
          </p>

          <h2>Δικαίωμα για χρήση πληροφοριών που παρέχονται από τους χρήστες</h2>

          <p>
            Όλες οι πληροφορίες που παρέχονται στην "ΙΣΤΟΣΕΛΙΔΑ" από τους Χρήστες αυτής της ιστοσελίδας
            (συμπεριλαμβανομένων, ενδεικτικά και όχι περιοριστικά, προσωπικών στοιχείων, τεχνογνωσίας, σχολίων,
            ιδεών, ερωτήσεων, τεχνικών, αποσπασμάτων ή άλλων παρόμοιων στοιχείων) δεν θεωρούνται εμπιστευτικές. Ο
            Χρήστης κατανοεί και αναγνωρίζει ότι η "ΕΤΑΙΡΕΙΑ" συλλέγει, χρησιμοποιεί, αποθηκεύει και άλλως
            επεξεργάζεται τις προσωπικές πληροφορίες και τα δεδομένα χρήσης του και δύναται να μοιραστεί τα δεδομένα
            αυτά με τρίτα μέρη για οποιοδήποτε σκοπό χωρίς περιορισμό. Σε καμία περίπτωση η "ΕΤΑΙΡΕΙΑ" δεν θα
            αποτρέψει τη χρήση των πληροφοριών αυτών για το σκοπό της ανάπτυξης, κατασκευής και προώθησης των
            προϊόντων της.
          </p>

          <h2>Αλλαγές στην ιστοσελίδα</h2>

          <p>
            Η "ΕΤΑΙΡΕΙΑ" επιφυλάσσεται του δικαιώματος να αλλάξει ή να αποσύρει οποιοδήποτε μέρος ή ολόκληρη την
            ιστοσελίδα οποιαδήποτε στιγμή χωρίς προηγούμενη ειδοποίηση. Οποιεσδήποτε αλλαγές θα ισχύσουν από την
            επόμενη φορά που ο Χρήστης θα επισκεφθεί την ιστοσελίδα. Οι Χρήστες αυτής της ιστοσελίδας δεν
            δικαιούνται οποιαδήποτε αποζημίωση επειδή αδυνατούν να χρησιμοποιήσουν τις υπηρεσίες που προσφέρονται
            από αυτήν.
          </p>

          <h2>Γενικά</h2>

          <p>
            Εάν οποιοδήποτε άρθρο των παραπάνω όρων θεωρείται ως μη εφαρμόσιμο, δεν θα επηρεάσει την εγκυρότητα και
            τη δυνατότητα εφαρμογής των υπόλοιπων όρων. Οι Όροι αυτοί αντιπροσωπεύουν τη συνολική συμφωνία μεταξύ
            του κάθε Χρήστη και της "ΙΣΤΟΣΕΛΙΔΑΣ" και διέπουν την πρόσβαση και την χρήση της ιστοσελίδας από την
            πλευρά των Χρηστών. Οι Όροι αυτοί υπερισχύουν κάθε άλλης γραπτής συμφωνίας μεταξύ του κάθε Χρήστη και
            της "ΕΤΑΙΡΕΙΑΣ" σε σχέση με τη χρήση αυτής της ιστοσελίδας. Οι Όροι αυτοί ερμηνεύονται σύμφωνα με την
            Ελληνική Νομοθεσία.
          </p>
        </div>
      </div>
    </main>

  </div>
</template>

<script>
import GymNavBar from './GymNavBar.vue'

export default {
  name: 'GymTerms',
  components: { GymNavBar },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');

/* ══════════════════════════════════════════
   BASE
══════════════════════════════════════════ */
.gym-page {
  font-family: 'Inter', sans-serif;
  background: #0f1923;
  color: rgba(255, 255, 255, 0.85);
  min-height: 100vh;
}

/* ══════════════════════════════════════════
   LAYOUT
══════════════════════════════════════════ */
.legal-wrapper {
  padding: 60px 1rem 80px;
}

.legal-container {
  max-width: 780px;
  margin: 0 auto;
}

/* ══════════════════════════════════════════
   HEADER
══════════════════════════════════════════ */
.legal-header {
  margin-bottom: 2.5rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.legal-header h1 {
  font-size: clamp(1.8rem, 4vw, 2.5rem);
  font-weight: 800;
  color: #fff;
  margin: 0 0 0.5rem;
}

.legal-subtitle {
  font-size: 0.875rem;
  color: rgba(255, 255, 255, 0.4);
  margin: 0;
}

/* ══════════════════════════════════════════
   BODY
══════════════════════════════════════════ */
.legal-body h2 {
  font-size: 1.1rem;
  font-weight: 700;
  color: #FFC947;
  margin: 2rem 0 0.75rem;
}

.legal-body p {
  font-size: 0.95rem;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.7);
  margin: 0 0 1.25rem;
}

/* ══════════════════════════════════════════
   RESPONSIVE
══════════════════════════════════════════ */
@media (max-width: 768px) {
  .legal-wrapper {
    padding: 40px 1.25rem 60px;
  }
}
</style>
